import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {BokkzTslDataService, Toeslagen, ToeslagenBerekening} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {Subject, takeUntil} from "rxjs";
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-berekening',
  templateUrl: './berekening.component.html',
  styleUrls: ['./berekening.component.scss'],
  imports: [
    CommonModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiAlertModule
  ]
})
export class BerekeningComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private destroy$ = new Subject<void>();
  public toeslagen = {} as Toeslagen;
  public toeslagenBerekening = {} as ToeslagenBerekening;
  public berekeningFg = {} as FormGroup;
  public totalenFG = {} as FormGroup;
  public kot = {} as number;
  public huur = {} as number;
  public kgb = {} as number;
  public zorg = {} as number;
  public saldo = {} as number;
  public allowanceId = ''
  public clientId: any;
  public aantalValidatiesValue = {} as number;

  constructor(
    public dataService: BokkzTslDataService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private dataTslService: BokkzTslDataService,
    ) {
    this.berekeningFg = this.fb.group<ToeslagenBerekening>({
      rechtOpZorgtoeslag: null as unknown as number,
      alOntvangenZorgtoeslag: null as unknown as number,
      verschuldigdeZorgtoeslag: null as unknown as number,
      rechtOpHuurtoeslag: null as unknown as number,
      alOntvangenHuurtoeslag: null as unknown as number,
      verschuldigdeHuurtoeslag: null as unknown as number,
      rechtOpKOT: null as unknown as number,
      alOntvangenKOT: null as unknown as number,
      verschuldigdeKOT: null as unknown as number,
      rechtOpKGB: null as unknown as number,
      alOntvangenKGB: null as unknown as number,
      verschuldigdeKGB: null as unknown as number,
    })
    this.totalenFG = this.fb.group({
      kot1: 0,
      kgb1: 0,
      huur1: 0,
      zorg1: 0,
      kot2: 0,
      kgb2: 0,
      huur2: 0,
      zorg2: 0,
      kot3: 0,
      kgb3: 0,
      huur3: 0,
      zorg3 : 0,
      sumToeslagen: 0,
      sumVoorschot: 0,
      sumSaldo: 0,
    })
  }

  public ngOnInit(): void {
    this.dataService.allowanceEntity.pipe(takeUntil(this.destroy$)).subscribe((allowanceEntity) => {
      this.toeslagen = allowanceEntity.toeslagen!;
    });
    this.dataService.tslBerekening.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.toeslagenBerekening = value;
      this.berekeningFg.patchValue(value,{emitEvent: false});

      const kot1 = value?.verschuldigdeKOT || 0;
      const kgb1 = value?.verschuldigdeKGB || 0;
      const huur1 = value?.verschuldigdeHuurtoeslag || 0;
      const zorg1 = value?.verschuldigdeZorgtoeslag || 0;

      const kot2 = value?.alOntvangenKOT || 0;
      const kgb2 = value?.alOntvangenKGB || 0;
      const huur2 = value?.alOntvangenHuurtoeslag || 0;
      const zorg2 = value?.alOntvangenZorgtoeslag || 0;

      const kot3 = value?.rechtOpKOT || 0;
      const kgb3 = value?.rechtOpKGB || 0;
      const huur3 = value?.rechtOpHuurtoeslag || 0;
      const zorg3 = value?.rechtOpZorgtoeslag || 0;

      const saldo = kot1 + kgb1 + huur1 + zorg1;

      this.kot = kot1;
      this.kgb = kgb1;
      this.huur = huur1;
      this.zorg = zorg1;
      this.saldo = saldo;

      this.totalenFG.patchValue({kot1: kot1 < 0 ? kot1 *-1 : kot1}, {emitEvent: false});
      this.totalenFG.patchValue({kgb1: kgb1 < 0 ? kgb1 *-1 : kgb1}, {emitEvent: false});
      this.totalenFG.patchValue({huur1: huur1 < 0 ? huur1 *-1 : huur1}, {emitEvent: false});
      this.totalenFG.patchValue({zorg1: zorg1 < 0 ? zorg1 *-1 : zorg1}, {emitEvent: false});
      this.totalenFG.patchValue({kot2:  kot2}, {emitEvent: false});
      this.totalenFG.patchValue({kgb2: kgb2}, {emitEvent: false});
      this.totalenFG.patchValue({huur2:  huur2}, {emitEvent: false});
      this.totalenFG.patchValue({zorg2:  zorg2}, {emitEvent: false});
      this.totalenFG.patchValue({kot3:  kot3}, {emitEvent: false});
      this.totalenFG.patchValue({kgb3:  kgb3}, {emitEvent: false});
      this.totalenFG.patchValue({huur3:  huur3}, {emitEvent: false});
      this.totalenFG.patchValue({zorg3:  zorg3}, {emitEvent: false});
      this.totalenFG.patchValue({sumSaldo:  saldo < 0 ? saldo *-1 : saldo}, {emitEvent: false});
      this.totalenFG.patchValue({sumVoorschot: kot2 + kgb2 + huur2 + zorg2}, {emitEvent: false});
      this.totalenFG.patchValue({sumToeslagen: kot3 + kgb3 + huur3 + zorg3}, {emitEvent: false});
    });
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.allowanceId = params["allowanceId"];
      this.clientId = params['clientId'];
      this.dataTslService.aantalValidaties.subscribe((aantalValidaties) => {
        this.aantalValidatiesValue = aantalValidaties;
      })

    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
